import Cookies from "js-cookie";
import { getModel } from "core-web/state";
import { getUUID } from "core-web/utils/getUUID";
import { hashString } from "core-web/utils/hashString";
import DataLayer from "./DataLayer";

export default async (data) => {
    const { application, page } = data;

    const algoliaUserToken = getUUID();

    const { userId } = getModel("user");
    const userIdCookie = Cookies.get("user_id");
    const { email } = getModel("user");
    const hashedUserEmailSHA1 = await hashString(email, "SHA-1");
    const userEmailCookie = Cookies.get("hashed_user_email");

    DataLayer.track({
        algoliaUserToken,
        event: "page_view",
        currency: application.currency.code,
        // site_id: application.applicationId,
        page_title: page.data.title || page.data.default_name || "404",
        page_type: page.type,
        page_template: page.template,
        userId: userId || userIdCookie,
        hashedUserEmailSHA1: hashedUserEmailSHA1 || userEmailCookie,
    });
};
